import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '../../../config/withDirection';

const StyleWrapper = styled.ul`
    margin: 0 auto;
    width: 100%;
    max-width: 893px;
    padding-right: 15px;
    padding-left: 15px;

    li.loading {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 26px 33px 26px 39px;
        background-color: rgba(0, 0, 0, .3);
        font-weight: 700;
        text-transform: uppercase;
    }
`;

export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/CampaignList/CampaignsHolder/Wrapper.js